import { Collection } from 'modules/core/lib/mobx-rest'

import DraftSupplement from 'modules/payroll_bundle/store/models/DraftSupplement'

class DraftSupplements extends Collection<DraftSupplement> {
  get cacheKey(): string {
    return 'draftSupplements'
  }

  model() {
    return DraftSupplement
  }
}

const singleton: DraftSupplements = new DraftSupplements([])

export default singleton
